module.exports = __webpack_public_path__ + "media/images/front/icon_trophy_gold-d746b740ac2101cc51eecd217746f795.png";